export default __webpack_public_path__ + "static/media/web-bill.182ab227.svg";